module.exports = __webpack_public_path__ + "static/media/vox-dislaimer-top-icon.945a3e18.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video-response/vox-dislaimer-top-icon.png
// module id = 650
// module chunks = 0